import PreferencesManager from "../../../components/sharedcomponents/preferenceManager";
import "../userDashboard.css";

export const UserPreferencePage = () => {

  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <PreferencesManager afterSaveRedirect={"/users/"}></PreferencesManager>
      </div>
    </>
  );
};

export default UserPreferencePage;
